var Curriculog = Curriculog || {};

Curriculog.Hermes = (function ($, _, Backbone, Hermes, util, dom) {
	/**
	 * DatasetImport
	 * 	This view attaches to the .dataset-import div on the Hermes import
	 * 	preview popup. It contains a select box and a list.
	 * 	  - The select is populated with the field names from the `MappedFields` collection.
	 * 	  - The list is populated with the `DatastoreAttributes` of the currently selected field.
	 */
	Hermes.DatasetImport = Curriculog.CurriculogView.extend({
		el: $('.dataset-import'),
		events: {
			'change select': 'preview'
		},
		initialize: function (options) {
			this.listenTo(this.collection, 'sync', this.render);
			this.listenTo(this.collection, 'request', this.showLoadingMask);
			this.collection.fetch();
		},
		/**
		 * Populate the `select` with options containing the `MappedField` names,
		 *   then preview the attributes for that field.
		 */
		render: function () {
			var view = this;

			this.collection.each(function (model) {
				var option = $('<option>', {
					value: model.get('fieldName'),
				})
					.html(model.get('fieldName'))
					.appendTo(view.$el.find('select'));

				// NOTE: this disables options that contain a slash.
				// This is because hermes doesn't support passing encoded slashes in the URL.
				// Once there is a better way to get the datastore attributes by ID, this
				// restriction can be removed.
				if (_.contains(option.val(), '/')) {
					option.prop('disabled', true);
				}
			});

			/**
			 * If we have json fields, they are stored under the key `hermes_json`
			 * so we will get that data first and fill out any json fields before
			 * populating the rest of the fields
			 */
			this.mappedField = new Hermes.MappedField({
				mapID: this.collection.mapID,
				fieldName: 'hermes_json',
				attributes: []
			});

			this.mappedField.fetchDatastoreAttributes().then(function (attributes) {
				view._addJsonFieldsToCollection(view, attributes);
			});

			this.preview();
		},

		/**
		 * Populate the `ul` with the `DatastoreAttributes` for the currently selected field.
		 */
		preview: function () {
			var thisView = this,
			    fieldName = this.$el.find('select :selected').val(),
			    xhr = {};

			this.mappedField = this.collection.findWhere({fieldName: fieldName});

			if (this.mappedField.get('attributesLoaded')) {
				this._renderResults(this.mappedField.get('attributes'));
			} else {
				xhr = this.mappedField.fetchDatastoreAttributes().then(function (attributes) {
					// Set `attributesLoaded` on the model so that we do not have to keep
					// making API calls if they select the same item multiple times
					thisView.mappedField.set('attributesLoaded', true);

					thisView._renderResults(attributes);
				});

				this.showLoadingMask(null, xhr);
			}
		},

		/**
		 * Find the model in the collection that corresponds with the
		 * json field and populate the attributes from the JSON data
		 */
		_addJsonFieldsToCollection: function (view, json) {
			// If there are multiple courses that hold JSON fields,
			// run through each course's JSON fields
			if (_.isArray(json)) {
				_.each(json, function (json) {
					view._parseJsonFields(view, json);
				});
			} else {
				view._parseJsonFields(view, json);
			}
		},

		_parseJsonFields: function (view, json) {
			var fields = JSON.parse(json);

			_.keys(fields).forEach(function (fieldName) {
				var model = view.collection.findWhere({fieldName: fieldName}),
					attributes = model.get('attributes');

				// If we have attributes set on the model already,
				// run through all the attributes and only add attibutes
				// that aren't already added to the model
				if (!_.isEmpty(attributes)) {
					attributes = _.reduce(fields[fieldName], function(attributes, value) {
						if (_.indexOf(attributes, value) === -1) {
							attributes.push(value);
						}

						return attributes;
					}, attributes);
				} else {
					attributes = fields[fieldName];
				}

				// Set `attributesLoaded` on the model so that we do not have to keep
				// making API calls if they select the same item multiple times
				model.set({
					attributes: attributes,
					attributesLoaded: true,
				});
			});
		},

		_renderResults: function (attributes) {
			results = !_.isEmpty(attributes)
				? this._buildDropdown(attributes)
				: '<span>No Options Available</span>';

			this.$el.find('.dataset-import-preview').html(results);
		},

		_buildDropdown: function (attributes) {
			var list = $('<ul>'),
			    view = this;

			if (_.isArray(attributes)) {
				attributes.forEach(function (attribute) {
					view._addAttribute(list, attribute);
				});
			} else if (_.isObject(attributes)) {
				_.keys(attributes).forEach(function (key) {
					view._addAttribute(list, attributes[key]);
				});
			} else {
				this._addAttribute(list, attributes);
			}

			return list;
		},

		/**
		 * Truncate to 255 characters and escape HTML.
		 */
		_processAttribute: function (attribute) {
			return util.escapeHTML(attribute);
		},

		_addAttribute: function (list, attribute) {
			this._processAttribute(attribute);

			list.append($('<li>').html(attribute));
		},

		showLoadingMask: function (_, xhr) {
			dom().addLoadingMask(this.el);
			xhr.done(this.hideLoadingMask.bind(this));
		},

		hideLoadingMask: function () {
			dom().removeMask(this.el);
		}
	});

	return Hermes;
})($, _, Backbone, Curriculog.Hermes || {}, Curriculog.util, dom);
